module.exports = __webpack_public_path__ + "media/images/demo/calendar-6e934e51df42a58de1b514f3208ee8f7.jpg";